export class AnalyticsView {
  title: string;
  description: string;
  viewType: number;
}

export class GeneralAnalytics {
  title: string;
  description: string;
  viewType: number;
}

//The full list of models
export interface ViewAnalyticsModel {
  definition: Definition;
  description: string;
  name: string;
  viewType: number;
  visibility: number;
}

export interface Definition {
  areaPathFilters: AreaPathFilter[];
  fieldFilters: FieldFilterData[];
  projectTeamFilters: ProjectTeamFilter[];
  workItemTypes: WorkItemTypes;
  backlogs: any[];
  isTeamFilterBySelectionMode: boolean;
  fieldSet: FieldSet;
  historyConfiguration: HistoryConfiguration;
}

export interface AreaPathFilter {
  projectId: string;
  operation: number;
  areaId: string;
}

export interface FieldFilter {
  id: string;
  index: number;
  fieldName: string;
  fieldOperation: number;
  value: WorkItemTypes;
  fieldValue: string | null;
  fieldValuesOperator: number;
  fieldDisplayName: string;
  unknownPropertyDisplayName?: string | null;
  fieldErrorMessage: string | null;
  valueErrorMessage: string | null;
  unknownValueText: string | null;
}

export interface FieldFilterData {
  fieldName: string;
  fieldOperation: number;
  value: WorkItemTypes;
  fieldValue: string | null;
  fieldValuesOperator: number;
  fieldDisplayName: string;
  unknownPropertyDisplayName?: string | null;
  fieldErrorMessage: string | null;
  valueErrorMessage: string | null;
  unknownValueText: string | null;
}

export interface WorkItemTypes {
  mode: number;
  operator: number;
  values: string[];
}

export interface FieldSet {
  fieldType: number;
  fields: string[];
}

export interface HistoryConfiguration {
  historyType: number;
  trendGranularity: TrendGranularity | null;
  rollingDays: number | null;
  dateRange: DateRange;
  excludeOldCompletedWorkItems: boolean;
  oldCompletedItemsCutoffDate: Date | null;
}

export interface DateRange {
  startDate: Date;
  endDate: Date | null;
}

export interface TrendGranularity {
  granularityType: number | null;
  weeklyEndDay: number | null;
}

export interface ProjectTeamFilter {
  projectId: string;
  teams: Teams;
}

export interface Teams {
  mode: number;
  operator: number;
}

export class AnalyticsFieldFilter {
  fieldFilters: FieldFilter[];
  constructor() {
    this.fieldFilters = [];
  }
}

export interface AnalyticsField {
  propertyName: string;
  displayName: string;
  isCommonField: boolean;
  isExpansion: boolean;
  wrapInQuotes: boolean;
  type: string;
  disallowFiltering: boolean;
  isDefaultField: boolean;
}

export class AnalyticsFieldColumnOptionTag {
  id: string;
  name: string;
  isDefault: boolean;
  internalName: string;
}

export interface AnalyticsViewAreaPath {
  AreaId: string;
  AreaName: string;
  AreaPath: string;
  Number: number;
}

export interface AnalyticsViews {
  ProjectSK: string;
  AreaId: string;
  AreaName: string;
  Number: number;
  AreaPath: string;
  Depth: number;
}

export interface GeneralTabValidationInfo {
  titleIsValid: boolean;
  descriptionIsValid: boolean;
}

export interface AnalyticsViews {
  id: string;
  name: string;
  description: string;
  visibility: Visibility;
  viewType: ViewType;
  createdBy: EdBy | null;
  createdDate: Date;
  lastModifiedBy: EdBy | null;
  lastModifiedDate: Date;
  _links: ValueLinks;
  url: string;
}

export interface ValueLinks {
  self: Self;
}

export interface Self {
  href: string;
}

export interface EdBy {
  displayName: string;
  url: string;
  _links: CreatedByLinks;
  id: string;
  uniqueName: string;
  imageUrl: string;
  descriptor: string;
}

export interface CreatedByLinks {
  avatar: Self;
}

export enum ViewType {
  WorkItems = 'workItems',
}

export enum Visibility {
  Private = 'private',
  Shared = 'shared',
}
